import dev from './dev.js';
import qa from './qa.js';
import qaNew from './qa-new.js';
import prod from './prod.js';
import pkgConfig from '../../package.json';

const backend = pkgConfig.config.backend;
const serviceProfile = pkgConfig.config.profile;

let config = null;

switch (backend) {
  case 'staging':
  case 'qa':
    if (serviceProfile) {
      config = qaNew;
    } else {
      config = qa;
    }
    break;
  case 'production':
  case 'prod':
    config = prod;
    break;
  default:
    config = dev;
}

export default config;
